/**
 * Created by lycheng on 2017/12/26.
 * SDK下载相关接口
 */
import 'babel-polyfill'
import { config } from 'config'
/**
 * 获取用户app
 */
function getApps () {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/product/getAppList`,
      type: 'get',
      dataType: 'json',
      cache: false,
      ifModified: true,
      success: function (result) {
        resolve(result)
      },
      error: function (s) {
      }
    })
  })
}
/**
 * 获取platform
 */
function getPlatforms () {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/product/platform`,
      type: 'get',
      dataType: 'json',
      cache: false,
      ifModified: true,
      success: function (result) {
        resolve(result)
      },
      error: function (s) {
      }
    })
  })
}
/**
 * 获取app开通的服务
 */
function getAppServiceList (data) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/product/getAppServiceList?appId=${data.appId}&platform=${data.platform}&aikit=${data.aikit}`,
      type: 'get',
      dataType: 'json',
      cache: false,
      ifModified: true,
      success: function (result) {
        resolve(result)
      },
      error: function (s) {
      }
    })
  })
}

/**
 * 获取MSC日志
 * @param appId
 * @returns {Promise}
 */
function getMscLog (platform) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/product/getMscLog?platform=${platform}`,
      type: 'get',
      dataType: 'json',
      success: function (result) {
        resolve(result)
      },
      error: function (s) {
      }
    })
  })
}

/**
 * 验证服务-老的sdk下载流程
 * @param params
 */
function getChargeInfo (params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `${config.API}sdk/dispatcher/getChargeInfo`,
      type: 'get',
      data: {
        app_id: params.appId,
        businessinfo: params.serviceId,
        platform: params.platform
      },
      dataType: 'json',
      success: function (result) {
        resolve({
          code: 0,
          data: result
        })
      },
      error: function () {
      }
    })
  })
}

/**
 * 老的下载流程
 * @param params
 */
function sdkDownloadOld (params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `${config.API}sdk/dispatcher/getChargeInfo`,
      type: 'get',
      data: {
        app_id: params.appId,
        businessinfo: params.serviceId,
        platform: params.platform
      },
      dataType: 'json',
      success: function (data) {
        var result = {}
        if (data.status) {
          result.code = 0
          result.data = `${config.API}sdk/download?app_id=${btoa(params.appId)}&business=${btoa(params.serviceId)}&platform=${btoa(params.platform)}`
        } else {
          result.flag = true
          result.code = -1
          result.desc = data
        }
        resolve(result)
      },
      error: function () {
      }
    })
  })
}
/**
 * 下载流程
 * @param params
 * @returns {Promise}
 */
function sdkDownload (params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/product/sdkDown`,
      type: 'post',
      contentType: 'application/json;charset=utf-8',
      data: JSON.stringify({
        platform: params.platform,
        appId: params.appId,
        abilities: params.abilities
      }),
      dataType: 'json',
      success: function (result) {
        resolve(result)
      },
      error: function () {
      }
    })
  })
}

/**
 * 选中服务时自动开通服务
 * @param params
 * @returns {Promise}
 */
function openService (params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/user/service`,
      type: 'get',
      data: {
        appId: params.appId,
        businessId: params.businessId
      },
      dataType: 'json',
      success: function (result) {
        resolve(result)
      },
      error: function () {
      }
    })
  })
}

export {
  getApps,
  getPlatforms,
  getAppServiceList,
  getMscLog,
  sdkDownloadOld,
  sdkDownload,
  openService
}



// WEBPACK FOOTER //
// ./src/js/api/sdk.js